var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "profile" }, [
    _c("section", { staticClass: "profile-number" }, [
      _c("a", { staticClass: "profile-link", attrs: { href: "javascript:" } }, [
        _c("div", { staticClass: "profile_image" }, [
          _c("img", {
            staticClass: "icon-person",
            attrs: { src: _vm.headimgurl }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "user-info" }, [
          _c("p", { staticClass: "user-info-top" }, [
            _vm._v(
              _vm._s(
                _vm.userInfo.nickName
                  ? _vm.userInfo.nickName
                  : _vm.userInfo.account
              )
            )
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("section", { staticClass: "profile_my_order border-1px" }, [
      _c(
        "a",
        {
          staticClass: "my_order",
          attrs: { href: "javascript:" },
          on: {
            click: function($event) {
              return _vm.gotoPath("/addressmanage")
            }
          }
        },
        [_vm._m(0), _vm._v(" "), _vm._m(1)]
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "my_order",
          attrs: { href: "javascript:" },
          on: {
            click: function($event) {
              return _vm.gotoPath("/order")
            }
          }
        },
        [_vm._m(2), _vm._v(" "), _vm._m(3)]
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "my_order",
          attrs: { href: "javascript:" },
          on: {
            click: function($event) {
              return _vm.gotoPath("/repairorder")
            }
          }
        },
        [_vm._m(4), _vm._v(" "), _vm._m(5)]
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "my_order",
          attrs: { href: "javascript:" },
          on: {
            click: function($event) {
              return _vm.gotoPath("/stop")
            }
          }
        },
        [_vm._m(6), _vm._v(" "), _vm._m(7)]
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "my_order",
          attrs: { href: "javascript:" },
          on: {
            click: function($event) {
              return _vm.gotoPath("/evaluateList")
            }
          }
        },
        [_vm._m(8), _vm._v(" "), _vm._m(9)]
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "my_order",
          attrs: { href: "javascript:" },
          on: {
            click: function($event) {
              return _vm.gotoPath("/updatephone")
            }
          }
        },
        [_vm._m(10), _vm._v(" "), _vm._m(11)]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _c("img", {
        staticClass: "iconImg iconOrderList",
        attrs: { src: require("./images/wd_icon1.png") }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "my_order_div" }, [
      _c("span", [_vm._v("地址管理")]),
      _vm._v(" "),
      _c("span", { staticClass: "my_order_icon" }, [
        _c("i", { staticClass: "iconfont iconNext" })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _c("img", {
        staticClass: "iconImg iconOrderList",
        attrs: { src: require("./images/wd_btn_1.png") }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "my_order_div" }, [
      _c("span", [_vm._v("缴费订单")]),
      _vm._v(" "),
      _c("span", { staticClass: "my_order_icon" }, [
        _c("i", { staticClass: "iconfont iconNext" })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _c("img", {
        staticClass: "iconImg iconOrderList",
        attrs: { src: require("./images/wd_btn_2.png") }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "my_order_div" }, [
      _c("span", [_vm._v("供热报修订单")]),
      _vm._v(" "),
      _c("span", { staticClass: "my_order_icon" }, [
        _c("i", { staticClass: "iconfont iconNext" })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _c("img", {
        staticClass: "iconImg iconOrderList",
        attrs: { src: require("./images/wd_btn_3.png") }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "my_order_div" }, [
      _c("span", [_vm._v("在线报停订单")]),
      _vm._v(" "),
      _c("span", { staticClass: "my_order_icon" }, [
        _c("i", { staticClass: "iconfont iconNext" })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _c("img", {
        staticClass: "iconImg iconOrderList",
        attrs: { src: require("./images/wd_btn_4.png") }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "my_order_div" }, [
      _c("span", [_vm._v("在线评价")]),
      _vm._v(" "),
      _c("span", { staticClass: "my_order_icon" }, [
        _c("i", { staticClass: "iconfont iconNext" })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _c("img", {
        staticClass: "iconImg iconOrderList",
        attrs: { src: require("./images/wd_btn_4.png") }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "my_order_div" }, [
      _c("span", [_vm._v("修改手机号")]),
      _vm._v(" "),
      _c("span", { staticClass: "my_order_icon" }, [
        _c("i", { staticClass: "iconfont iconNext" })
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4e150caf", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e150caf","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Profile/Profile.vue
// module id = null
// module chunks = 